module.exports = __webpack_public_path__ + "static/priviliges-6-ee9a878bc0ab2d33c65d9abbfa919249.png";